import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { ModalAlert, Notice } from "components/common-ui";
import LinkUpStore from "../link-up.store";

type SelectContactsProps = {
    display: boolean,
    cancellationToken: any,
    onSend: any,
    onGoBack: any,
    store: LinkUpStore
}

const SelectContacts = observer((props: SelectContactsProps) => {
    const { display, cancellationToken, store, onSend, onGoBack } = props;
    const [isSending, setIsSending] = useState(false);
    const [selectionCount, setSelectionCount] = useState(0);

    const getSelectedOptions = () => store.deliveryOptions?.filter((x: { isSelected: boolean; }) => x.isSelected === true);

    const selectValue = (value: any) => {
        store.deliveryOptions.forEach((o: { [x: string]: boolean; }) => o["isSelected"] = o === value);

        setSelectionCount(1);
    }

    const send = async (e: any) => {
        if (e != null) {
            e.preventDefault();
        }

        const selectedOptions = getSelectedOptions();

        if (selectedOptions.length === 0) {
            ModalAlert.alert("OTP", "You must select where to send the verification code to.");
            return;
        }

        setIsSending(true);

        await onSend(selectedOptions[0]);

        setIsSending(false);
    }

    const goBack = (e: any) => {
        if (e != null) {
            e.preventDefault();
        }

        cancellationToken.cancel();

        setIsSending(false);

        setSelectionCount(0);

        onGoBack();
    }

    if (display !== true) {
        return null;
    }

    const isDisabled = selectionCount === 0;
    const submitButtonCssName = isDisabled ? " disabled" : "";

    return (
        <Notice className="select-contacts">
            <h1>Almost there! We're just confirming that this is you</h1>

            <p>
                For security reasons, we need to confirm your details before we link your account.
            </p>
            <p>
                Where would you like us to send the verification code to?
            </p>

            <ul>
                {store.deliveryOptions ? store.deliveryOptions.map((o: any, index: number) =>
                    <li key={index}>
                        <input type="radio" className="jcf-radio" name="contact" onClick={(e) => selectValue(o)} value={o.key} id={`contact-${o.key}`} />
                        <label htmlFor={`contact-${o.key}`}>{o.value}</label>
                    </li>
                ) : null}
            </ul>

            {/* <p>
                None of these are my contact information.&nbsp;
                Feature not available yet <span className="anchor">Use live chat to talk to someone now.</span>
            </p> */}

            {isSending ?
                <p className="processing">Sending</p> :
                <button className={`btn btn-black${submitButtonCssName}`}
                    disabled={isDisabled}
                    onClick={send}>Continue</button>}

            <span className="anchor action go-back" onClick={goBack}>Back</span>
        </Notice>
    );
});

export default SelectContacts;
